import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const emptyPagination = {
  totalCount: 0,
  currentPageCount: 0,
  NumberOfPage: 0,
  perPage: 12,
  currentPage: 1,
};

export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Contact'],
  endpoints: (builder) => ({
    getContacts: builder.query({
      query: (page = 1) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/contact-list',
          method: 'GET',
          params: { page, 'access-token': token },
        };
      },
      transformResponse: (response) => {
        if (response?.status === 1) {
          const payload = response.data?.[0] || {};
          return {
            items: payload.items || [],
            meta: payload._meta || emptyPagination,
          };
        }
        return { items: [], meta: emptyPagination };
      },
      providesTags: ['Contact'],
    }),
    getContactById: builder.query({
      query: (contactId) => {
        const token = cookies.get('authToken');
        const formData = new FormData();
        formData.append('contact_id', contactId);
        return {
          url: 'api/web/v1/site/contact-view',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      transformResponse: (response) => {
        if (response?.status === 1) {
          return response.data?.[0] || null;
        }
        return null;
      },
    }),
  }),
});

export const {
  useGetContactsQuery,
  useLazyGetContactByIdQuery,
} = contactApi;

